// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineBulletedList_list__HB-wW","listItem":"InlineBulletedList_listItem__U_D68","compact":"InlineBulletedList_compact__2TWOr"};